import { Box, Drawer, useMediaQuery } from "@mui/material";
import PatientDetails from "../Components/Prescription/PatientDetails";
import DoctorDetail from "../Components/Prescription/DoctorDetail";
import Sidebar from "../Components/Prescription/Sidebar";
import { useState } from "react";
import { prescriptionWrapper } from "../style/PatientReportStyle";
import MedicineListing from "../Components/Prescription/AdminShortCuts/MedicineListing";
import TreatmentTemplate from "../Components/Prescription/AdminShortCuts/TreatmentTemplate";
import DosageList from "../Components/Prescription/AdminShortCuts/DosageList";
import TestShortCuts from "../Components/Prescription/AdminShortCuts/TestShortCuts";
import Diagnosis from "../Components/Prescription/AdminShortCuts/Diagnosis";
import MedicineRemarks from "../Components/Prescription/AdminShortCuts/MedicineRemarks";
import FollowUpList from "../Components/Prescription/AdminShortCuts/FollowUpList";
import SpecialInstructions from "../Components/Prescription/AdminShortCuts/SpecialINstructions";
import Enquiries from "../Components/ModalChildren/Enquiries";
import ChatBotLauncher from "../Components/Prescription/ChatBotIcon";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { IconButton } from "@mui/material";
import DrawerSliderMobile from "../Components/Prescription/DrawerSliderMobile";
import { closeMobileSidebar } from "../redux/slices/uiSlice";
import { useDispatch, useSelector } from "react-redux";

const Prescription = () => {
  const isMdUp = useMediaQuery("(min-width:600px)");

  const [active, setActive] = useState("Home");
  const [openChat, setOpenChat] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (active) {
      case "Home":
        return (
          <>
            <PatientDetails />
            <DoctorDetail />
          </>
        );

      case "Medicine List":
        return <MedicineListing />;

      case "Treatment Templates":
        return <TreatmentTemplate />; //

      case "Dosage List":
        return <DosageList />;

      case "Test Shortcodes":
        return <TestShortCuts />; //

      case "Diagnosis":
        return <Diagnosis />;

      case "Special Instructions":
        return <SpecialInstructions />;

      case "Medicine Remarks":
        return <MedicineRemarks />;

      case "Followup Lists":
        return <FollowUpList />;

      default:
        return <div>Select an option</div>;
    }
  };

  const dispatch = useDispatch();
  const isMobileSidebarOpen = useSelector(
    (state) => state.ui.isMobileSidebarOpen
  );

  return (
    <Box
      sx={{
        ...prescriptionWrapper,
        position: "relative",
        ...(isMdUp && {
          paddingLeft: isSidebarOpen ? "0px" : "19px",
        }),
      }}
    >
      {isMdUp && !isSidebarOpen && (
        <Box
          onClick={() => setIsSidebarOpen(true)}
          sx={{
            position: "fixed",
            left: 0,
            top: "90%",
            transform: "translateY(-50%)",
            width: 26,
            height: 55,
            backgroundColor: "#007A99", // theme teal
            borderRadius: "0 12px 12px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 999,
            boxShadow: "2px 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          <ArrowForwardIosIcon sx={{ color: "#fff", fontSize: 16 }} />
        </Box>
      )}

      {isMdUp && isSidebarOpen && (
        <Box
          onClick={() => setIsSidebarOpen(false)}
          sx={{
            position: "fixed",
            left: 72, // sidebar width
            top: "90%",
            transform: "translateY(-50%)",
            width: 26,
            height: 55,
            backgroundColor: "#007A99",
            borderRadius: "12px 0 0 12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 999,
            boxShadow: "2px 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          <ArrowBackIosNewIcon sx={{ color: "#fff", fontSize: 16 }} />
        </Box>
      )}

      {isSidebarOpen && <Sidebar active={active} setActive={setActive} />}

      <DrawerSliderMobile
        open={isMobileSidebarOpen}
        onClose={() => dispatch(closeMobileSidebar())}
        active={active}
        setActive={setActive}
      />

      {/* 👉 MAIN CONTENT */}
      {renderContent()}

      {/* 👉 CHAT */}
      {active === "Home" && !openChat && (
        <ChatBotLauncher onClick={() => setOpenChat(true)} />
      )}

      {/*  Chat Drawer */}
      <Drawer
        anchor="right"
        open={openChat} // ✅ boolean
        onClose={() => setOpenChat(false)}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 500 }, // 📱 mobile width
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Enquiries onClose={() => setOpenChat(false)} />
      </Drawer>
    </Box>
  );
};

export default Prescription;
